import {
  BUTTERSCOTCH_500,
  DUSTY_ORANGE_600,
  GREEN_400,
  OLD_MAUVE_500,
  PICTON_BLUE_400,
  PLUM_PURPLE_500,
} from "../common/colors";

export const primaryCategories = Object.freeze({
  unread: "unread",
  actionable: "actionable",
  muted: "muted",
});

export const secondaryCategories = Object.freeze({
  session_update: "session_update",
  client_management: "client_management",
  documentation: "documentation",
  supervision: "supervision",
  insights: "insights",
  provider_tagging: "provider_tagging",
});

export const secondaryCategoryColors = Object.freeze({
  session_update: BUTTERSCOTCH_500,
  client_management: PICTON_BLUE_400,
  documentation: GREEN_400,
  supervision: PLUM_PURPLE_500,
  insights: OLD_MAUVE_500,
  provider_tagging: DUSTY_ORANGE_600,
});

export const categoryParamsMap = Object.freeze({
  unread: "isUnread",
  actionable: "isActionable",
  muted: "isMuted",
});
